export default __webpack_public_path__ + "static/media/policy10_2023.78eb00da.jpg";